module.exports = __webpack_public_path__ + "img/5.800c058e.png";